import type {StateManager} from 'shared/state-manager';
import type {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';

export class DerivedStateManager<STATE> implements StateManager<STATE> {

    constructor(private sourceStateManager: StateManager<STATE>, private modifier: (state: STATE) => STATE, private filteredParams?: (params: STATE) => boolean) {
    }

    getState$(): Observable<STATE> {
        return this.sourceStateManager.getState$().pipe(
            filter(this.filteredParams),
            map(this.modifier)
        );
    }

    requestChangeState(newParams: STATE): void {
        this.sourceStateManager.requestChangeState(newParams);
    }

    requestChangeStateParameter<T extends keyof STATE>(parameterName: T, newValue: STATE[T]): void {
        this.sourceStateManager.requestChangeStateParameter(parameterName, newValue);
    }

}